export function buildController(engine) {
    let prevState;
    const listeners = new Map();
    const hasNoListeners = () => listeners.size === 0;
    const hasStateChanged = (currentState) => {
        try {
            const stringifiedState = JSON.stringify(currentState);
            const hasChanged = prevState !== stringifiedState;
            prevState = stringifiedState;
            return hasChanged;
        }
        catch (e) {
            console.warn('Could not detect if state has changed, check the controller "get state method"', e);
            return true;
        }
    };
    return {
        subscribe(listener) {
            listener();
            const symbol = Symbol();
            let unsubscribe;
            if (hasNoListeners()) {
                prevState = JSON.stringify(this.state);
                unsubscribe = engine.subscribe(() => {
                    if (hasStateChanged(this.state)) {
                        listeners.forEach((listener) => listener());
                    }
                });
            }
            listeners.set(symbol, listener);
            return () => {
                listeners.delete(symbol);
                if (hasNoListeners()) {
                    unsubscribe?.();
                }
            };
        },
        get state() {
            return {};
        },
    };
}
